{
  "columnResizer": "Narzędzie zmiany rozmiaru kolumny",
  "loading": "Ładowanie...",
  "loadingMore": "Wczytywanie większej liczby...",
  "resizeColumn": "Zmień rozmiar kolumny",
  "sortAscending": "Sortuj rosnąco",
  "sortDescending": "Sortuj malejąco"
}
